import { RootState } from 'models';

const selectTablesSelectValues = (state: RootState) => state.configurator.tables.tablesSelectValues;

const selectActiveTable = (state: RootState) => state.configurator.tables.activeTable;

const selectTable = (state: RootState) => state.configurator.tables.tablesSelectValues;

const selectTableColumns = (state: RootState) => state.configurator.tables.tableColumns;

const selectTableRows = (state: RootState) => state.configurator.tables.tableRows;

const selectExternalTablesRowSelected = (state: RootState) => state.configurator.tables.externalTablesRowSelected;

const selectCompanyPriv = (state: RootState) => state.configurator.tables.companyPriv;

const selectSelectedRow = (state: RootState) => state.configurator.tables.selectedRow;

const selectTablesEditRowID = (state: RootState) => state.configurator.tables.editRowID;

const selectTableMode = (state: RootState) => state.configurator.tables.tableMode;

export default {
  selectTablesSelectValues,
  selectActiveTable,
  selectTable,
  selectExternalTablesRowSelected,
  selectTableMode,
  selectTablesEditRowID,
  selectSelectedRow,
  selectCompanyPriv,
  selectTableRows,
  selectTableColumns,
};
